import React from 'react'
import PropTypes from 'prop-types'
import messages from './messages'
import { FormattedMessage } from 'react-intl'
import check from 'media/check.svg'
import useBreakpoints from 'js/hooks/useBreakpoints'

const FeatureItem = ({ children }) => {
  const { LG } = useBreakpoints()
  return (
    <li
      className="py-8 pl-30 pr-24 md:w-1/2 lg:pl-36"
      style={{
        background: `url(${check}) 0 12px no-repeat`,
        backgroundSize: LG ? 'auto' : '18px',
      }}
    >
      {children}
    </li>
  )
}

FeatureItem.propTypes = {
  children: PropTypes.node,
}

export default function TopFeatures({ features }) {
  const { MD, LG, XL, XXL } = useBreakpoints()
  const width = XXL
    ? '900px'
    : XL
    ? '800px'
    : LG
    ? '700px'
    : MD
    ? '100%'
    : '80%'

  if (features) {
    return (
      <div
        className="mx-auto mt-24 text-left md:mt-40"
        style={{ width: width }}
      >
        <ul className="md:flex md:flex-wrap md:justify-between">
          {features.map((feature, index) => (
            <FeatureItem key={`feature-${index}`}>
              {feature.heading}
              <div className="text-grey type-14">{feature.body}</div>
            </FeatureItem>
          ))}
        </ul>
      </div>
    )
  }
  return (
    <div className="mx-auto mt-24 text-left md:mt-40" style={{ width: width }}>
      <ul className="md:flex md:flex-wrap md:justify-between">
        <FeatureItem>
          <FormattedMessage {...messages.plans} />
        </FeatureItem>
        <FeatureItem>
          <FormattedMessage {...messages.twwl} />
        </FeatureItem>
        <FeatureItem>
          <FormattedMessage {...messages.tracking} />
        </FeatureItem>
        <FeatureItem>
          <FormattedMessage {...messages.recipes} />
        </FeatureItem>
        <FeatureItem>
          <FormattedMessage {...messages.sync} />{' '}
          <div className="leading-body text-grey type-14">
            (Samsung Health, Apple Health, Google Fit, Android Health,
            Runkeeper, Fitbit, Jawbone &amp; Endomondo)
          </div>
        </FeatureItem>
        <FeatureItem>
          <FormattedMessage {...messages['upgrade.checklist_lifescore']} />
        </FeatureItem>
      </ul>
    </div>
  )
}

TopFeatures.propTypes = {
  features: PropTypes.array,
}
